import React from 'react';
import { Image } from 'antd';
import classNames from 'classnames';
import { MessageQuestionIcon } from 'icons';
import { useTranslations } from 'next-intl';

import { useAppDispatch } from 'store';

import { IDTMQuestion } from 'modules/dtm-test';
import { setQuestionId, setTestFeedbackModal } from 'modules/global';
import { useOptionState } from 'modules/national-certificate-check';

import { MathJaxContext } from 'components';

interface IProps {
  test?: IDTMQuestion;
  testName?: string;
  currentQuestion?: number;
  questionsLength?: number;
}

export const ResultQuizCard: React.FC<IProps> = ({ test, testName, currentQuestion, questionsLength }) => {
  const t = useTranslations();
  const dispatch = useAppDispatch();
  const { getStateClass, getInnerBorderClass } = useOptionState(test?.checked as number);

  const onOpenFeedbackModal = () => {
    dispatch(setQuestionId(test?.question_id as number));
    dispatch(setTestFeedbackModal(true));
  };

  return (
    <>
      <div className="shadow-xs mb-3 rounded-xl bg-white px-4 py-3">
        <div className="flex items-center justify-between">
          <div className="text-xs text-gray-500">
            {currentQuestion}/{questionsLength} • {testName}
          </div>
          <div className="flex items-center gap-2">
            {!test?.checked && (
              <div className=" rounded-lg bg-gray-200 px-3 py-0.5 text-xs text-gray-700">{t('belgilanmagan')}</div>
            )}
            <div onClick={onOpenFeedbackModal} className="flex cursor-pointer items-center gap-2 text-orange-400">
              <MessageQuestionIcon />
            </div>
          </div>
        </div>
        <div className="mt-3 min-w-0 overflow-x-auto overflow-y-hidden">
          <div className="inline-block whitespace-pre-line text-sm font-medium">
            <MathJaxContext expression={test?.question_name} />
          </div>
        </div>
        {test?.image && (
          <div className="flex justify-center">
            <Image src={test.image} alt={test?.name} loading="lazy" title="Test image" />
          </div>
        )}
      </div>

      <div className="shadow-xs mb-4 rounded-xl bg-white px-4 py-3">
        <div className="space-y-3">
          {test?.options?.map((option, index) => (
            <div key={option.id} className={classNames('rounded-xl border-2', getStateClass(option))}>
              <div
                className={classNames(
                  'flex cursor-pointer items-center gap-3 rounded-xl border p-3 transition-all',
                  getInnerBorderClass(option)
                )}
              >
                <span className="font-semibold text-gray-600">{String.fromCharCode(97 + index)})</span>
                <div className="min-w-0 flex-1 overflow-x-auto overflow-y-hidden">
                  <p className="inline-block whitespace-pre-line text-xs text-gray-800">
                    <MathJaxContext expression={option?.name} />
                  </p>
                  {option?.image && (
                    <div className="mt-2 flex justify-center">
                      <Image
                        src={option?.image}
                        alt={option?.name || 'Test option'}
                        loading="lazy"
                        title="Test image"
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};
